import React from "react";
import { Col, Row } from "react-bootstrap";
import { Progress } from "antd";
import { useTranslation } from "react-i18next";

export const BusStatusSection = ({
  count,
  totalCount,
  label,
}) => {
  const { t } = useTranslation();

  // Calculate completion status
  const isComplete = count === totalCount && totalCount > 0;
  const progressPercentage =
    totalCount > 0 ? (count / totalCount) * 100 : 0;

  // Conditional styling based on completion
  const containerStyle = {
    backgroundColor: isComplete ? "#EFFDF4" : "#FAF8F6",
    border: `1px solid ${isComplete ? "#BBF7CF" : "#E5E4E2"}`,
    borderRadius: "8px",
    padding: "16px",
    marginTop: "12px",
    marginBottom: "12px",
  };

  return (
    <Row className="mx-0">
      <Col xs={12} className="p-0">
        <div style={containerStyle}>
          <div className="H7 text-secondary mb-1">{t(label)}</div>
          <div className="H6 text-primary mb-2">
            {label === "ARRIVAL_CARD_BUS_ARRIVAL_STATUS"
              ? t("ARRIVED")
              : t("DEPARTED")}{" "}
            {count} {t("FROM")} {totalCount}
          </div>
          <Progress
            percent={progressPercentage}
            strokeColor="#15A448"
            trailColor={isComplete ? "#EFFDF4" : "#F6F6F9"}
            showInfo={false}
            strokeWidth={8}
          />
        </div>
      </Col>
    </Row>
  );
};
